<template>
  <div>
    

    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      :pageConfig="pageConfig"
      :buttonList="buttonList"
      @btnCallFunction="callFunction"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
    >
      <template v-slot:orgId>
        <el-select multiple filterable v-model="filters.orgId" placeholder="请选择" collapse-tags>
          <el-option
            v-for="item in organizations"
            :label="item.customName"
            :value="item.id"
            :key="item.id"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:warehouseId>
        <el-select multiple filterable v-model="filters.warehouseId" placeholder="请选择" collapse-tags>
          <el-option
            v-for="item in warehouses"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:tdate>
        <el-date-picker
          v-model="filters.tdate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </template>
    </TwTable>
   </div>
</template>

<script>
import {
  getInventoryDetailAsync,
  exportInventoryDetailOut,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import TwTable from "../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import { getCustomerList } from "@/api/ProductSku.js";
import axios from "axios";
import { thereAre } from "util/util";
export default {
  components: { TwTable },
  mixins: [TwTable_mixins],
  data() {
    return {
      tableConfig: {
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: false, // 显示操作栏
        operate: {
          // 表格操作配置
        },
        column: [
          // 表格列配置
          {
            prop: "inventoryBatchIOLogID",
            label: "出入明细编号",
            align: "center",
            sortable: true,
            
          },

          {
            prop: "warehouseName",
            label: "仓库",
            align: "center",
            sortable: true,
          },
          {
            prop: "locationCode",
            label: "库位",
            align: "center",
            sortable: true,
          },
          {
            prop: "customName",
            label: "客户",
            align: "center",
            sortable: true,
          },
          {
            prop: "sku",
            label: "SKU",
            align: "center",
            sortable: true,
            minWidth: "120",
          },
          {
            prop: "inventoryIOType",
            label: "出入库类型",
            align: "center",
            minWidth: "120",
            sortable: true,
          },
          {
            prop: "batchCode",
            label: "批次号",
            align: "center",
            minWidth: "120",
            sortable: true,
          },

          {
            prop: "qty",
            label: "数量",
            align: "center",
            sortable: true,
          },

          {
            prop: "createTime",
            label: "过账时间",
            align: "center",
            sortable: true,
          },
          {
            prop: "createUser",
            label: "过账用户",
            align: "center",
            sortable: true,
          },
        ],
      },
      searchData: {
        //搜索列配置

        search: [
          {
            type: "select",
            key: "orgId",
            prop: "orgId",
            label: "客户",
            multiple: true,
            slot: true,
            placeholder: "请选择客户",
            option: this.organizations,
          },
          {
            type: "select",
            key: "warehouseId",
            prop: "warehouseId",
            label: "仓库",
            multiple: true,
            slot: true,
            placeholder: "请选择客户",
            option: this.warehouses,
          },
          {
            type: "input",
            key: "prosku",
            label: "SKU",
            placeholder: "多个SKU用逗号分开查询",
            clearable: true,
          },
          {
            type: "input",
            key: "batchCode",
            label: "批次号",
            placeholder: "多个批次号用逗号分开查询",
            clearable: true,
          },
          {
            key: "tdate",
            prop: "tdate",
            slot: true,
            label: "过账时间",
          },
        ],
        ///高级搜索配置
        moreSearch: [],
      },
      buttonList: [],

      //-------------
      filters: {
        orgId: "",
        warehouseId: "",
        prosku: "",
        batchCode: "",
        tdate: "",
      },
      organizations: [],
      warehouses: [],
    };
  },
  methods: {
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.newfilters =JSON.parse(JSON.stringify(this.filters)) 
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },

    //查询列表
    initTable() {
      const { orgId, warehouseId, prosku, batchCode, tdate } =  this.newfilters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        orgId: thereAre(orgId),
        warehouseId: thereAre(warehouseId),
        prosku,
        batchCode,
      };
      if (tdate != null && tdate != "null") {
        para.startdate = tdate[0];
        para.enddate = tdate[1];
      }
      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      getInventoryDetailAsync(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;

        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);
        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
      });
    },
    //导出
    handleExport() {
      let row = this.selectRows.rows;

      let tsDeliveryInfoIDs = "";
      row.forEach((item) => {
        tsDeliveryInfoIDs += item.inventoryBatchIOLogID + ",";
      });

      const { orgId, warehouseId, prosku, batchCode, tdate } =  this.newfilters;
      let pata = {
        page: 1,
        pageSize: 60001,
        orgId: thereAre(orgId),
        warehouseId: thereAre(warehouseId),
        prosku,
        batchCode,
        inventoryBatchStorageIDList: thereAre(tsDeliveryInfoIDs),
      };
      if (tdate != null && tdate != "null") {
        pata.startdate = tdate[0];
        pata.enddate = tdate[1];
      }
      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios({
        url: exportInventoryDetailOut,
        method: "post",
        data: pata,
        //responseType: "blob",
      })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;

            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },
  },

  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);

    let user = JSON.parse(window.localStorage.user);
    this.warehouses = user.warehouseList;
    let para = {
      IsAll: true,
    };
    getCustomerList(para).then((res) => {
      this.organizations = res.data.response;
    });
  },
};
</script>

